// (function() {
// 	const addonCheckboxes = document.getElementsByClassName("js-addon-selection-card");

// 	for (let i = 0; i < addonCheckboxes.length; i++) {
// 		addonCheckboxes[i].addEventListener("change", function() {
			
// 			const labels = this.labels;
// 			for (let i = 0; i < labels.length; i++) {

// 				if (labels[i].classList.contains("js-info")) {
// 					if (this.checked) {
// 						labels[i].textContent = labels[i].dataset.selected;
// 					} else {
// 						labels[i].textContent = labels[i].dataset.select;
// 					}
// 				}
// 			}
// 		});
// 	}
// })();

(function() {
	const addonRadios = document.getElementsByClassName("js-radio-label");

	for (let i = 0; i < addonRadios.length; i++) {
		addonRadios[i].addEventListener("click", function(event) {
			
			const radio = document.getElementById(event.target.htmlFor);

			if ( radio && radio.checked ) {

				setTimeout(() => {
					
					radio.checked = false;
				}, 50);
			}
		});
	}
})();